import { useState } from 'react'
import { Trans as TranslationComponent, useTranslation } from 'react-i18next'
import unescape from 'lodash-es/unescape'

import { SIZE } from '../../../../constants/size'
import { ConfirmationModal } from '../../../Confirmation'
import Text from '../../../Text'
import {
  getChatroomSystemMessageTranslationKey,
  isChatroomSystemMessageAddUserWithComment,
} from '../ChatroomSystemMessage.utils'
import { ChatroomSystemMessageUserLink } from '../ChatroomSystemMessageUserLink'
import { ChatroomSystemMessageUserListLinks } from '../ChatroomSystemMessageUserListLinks'

import * as styles from '../ChatroomSystemMessage.module.css'

function ChatroomSystemMessageContent({ message }) {
  const { t } = useTranslation()

  const [isCommentModalOpen, setCommentModalOpen] = useState(false)

  function handleOpenCommentModal() {
    setCommentModalOpen(true)
  }

  function handleCloseCommentModal() {
    setCommentModalOpen(false)
  }

  const translationKey = getChatroomSystemMessageTranslationKey(message)

  const owner = message.initiator || message.owner_obj

  const isCommentInline = isChatroomSystemMessageAddUserWithComment(message)

  // The backend HTML-escapes this field; the request-log endpoint does not.
  const comment = unescape(message.comment)

  return translationKey ? (
    <>
      <TranslationComponent
        components={{
          comment: isCommentInline ? (
            <Text className={styles.comment}>{comment}</Text>
          ) : (
            <Text
              className={styles.commentButton}
              onClick={handleOpenCommentModal}
            />
          ),
          owner: (
            <ChatroomSystemMessageUserLink
              className={styles.link}
              user={owner}
            />
          ),
          users: (
            <ChatroomSystemMessageUserListLinks
              linkClassName={styles.link}
              users={message.user_list}
            />
          ),
        }}
        i18nKey={translationKey}
      />
      {isCommentModalOpen ? (
        <ConfirmationModal
          actionButtonsProps={{
            Cancel: null,
            submitText: t('Modal.ConfirmBtnKey'),
          }}
          boxSize={SIZE.LARGE}
          contentProps={{ className: styles.commentContent }}
          description={comment}
          title={t('Chatroom.SystemMessageCommentModalTitleKey')}
          onClose={handleCloseCommentModal}
          onSubmit={handleCloseCommentModal}
        />
      ) : null}
    </>
  ) : (
    message.text
  )
}

export default ChatroomSystemMessageContent
